"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetGroupChartData = void 0;
var _react = require("react");
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _selectors = require("../redux/selectors");
var _devices = require("../redux/actions/devices");
var _useGetChartData = require("./useGetChartData");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useGetGroupChartData = _ref => {
  let {
    chartId,
    equipmentKey
  } = _ref;
  const dispatch = (0, _reactRedux.useDispatch)();
  const hasData = (0, _reactRedux.useSelector)(_selectors.selectHasData);
  const activeBuildingId = (0, _reactRedux.useSelector)(_selectors.selectActiveBuilding);
  const devicesForChartRequest = (0, _reactRedux.useSelector)((0, _selectors.selectDevicesForChartRequestByKey)({
    equipmentKey,
    chartId
  }), _paulCorePackage.functions.areEqual);
  (0, _react.useEffect)(() => {
    if (hasData && activeBuildingId) {
      dispatch((0, _devices.setActiveGroup)({
        chartId,
        equipmentKey
      }));
    }
  }, [dispatch, hasData, chartId, equipmentKey, activeBuildingId]);
  (0, _useGetChartData.useGetChartData)({
    chartId,
    devicesForChartRequest
  });
};
exports.useGetGroupChartData = useGetGroupChartData;
useGetGroupChartData.propTypes = {
  chartId: _propTypes.default.string,
  equipmentKey: _propTypes.default.string
};